<div class="content-body pt-0">
  <div class="form-field-title">
    <p>{{ headerText }}</p>
  </div>
  <div class="sidenav-table sidenav-table-input wp-100">
    <div class="mat-table-wrapper product-detail-table">
      <form [formGroup]="formReceiptDetail">
        <ng-container formArrayName="receiptDetailArray">
          <table
            aria-describedby="receipt-list"
            mat-table
            [dataSource]="tableDataSource"
          >
            <ng-container matColumnDef="invoiceNo">
              <th mat-header-cell *matHeaderCellDef class="w-20">Sr No.</th>
              <td
                mat-cell
                *matCellDef="let element; let i = index"
                [formGroupName]="i"
              >
                <div class="d-flex">
                  {{ i + 1 }}
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="note">
              <th mat-header-cell *matHeaderCellDef>Note</th>
              <td
                mat-cell
                *matCellDef="let element; let i = index"
                [formGroupName]="i"
                class="widthemail"
              >
                <mat-form-field floatLabel="auto" class="wp-100">
                  <input
                    matInput
                    [value]="element.note"
                    autocomplete="off"
                    formControlName="note"
                  />
                </mat-form-field>
              </td>
            </ng-container>
            <ng-container matColumnDef="invoiceReceipt">
              <th mat-header-cell *matHeaderCellDef>
                {{ invoiceText }}
                <span class="text-danger-300">*</span>
              </th>

              <td
                mat-cell
                *matCellDef="let element; let i = index"
                [formGroupName]="i"
                class="widthemail"
              >
                <mat-form-field floatLabel="auto">
                  <mat-select
                    #transactionType
                    (selectionChange)="onInvoiceChange($event.value, i)"
                    [disableOptionCentering]="true"
                    formControlName="invoiceReceipt"
                    dropdownPosition="top"
                    panelClass="mat-select-position"
                  >
                    <mat-option
                      *ngFor="let tt of invoiceList[i]"
                      [value]="tt.id"
                      title="{{ tt.name }}"
                    >
                      <span class="clamp">{{ tt.name }}</span>
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </td>
            </ng-container>
            <ng-container matColumnDef="invoiceAmount">
              <th mat-header-cell *matHeaderCellDef class="w-200">
                {{ amountText }}
              </th>
              <td
                mat-cell
                *matCellDef="let element; let i = index"
                [formGroupName]="i"
              >
                <mat-form-field floatLabel="auto" class="wp-100">
                  <input
                    allowDecimal
                    matInput
                    [value]="element.invoiceAmount"
                    autocomplete="off"
                    formControlName="invoiceAmount"
                    maxlength="{{ maxLength.maxLength10 }}"
                  />
                </mat-form-field>
              </td>
            </ng-container>
            <ng-container matColumnDef="dueAmount">
              <th mat-header-cell *matHeaderCellDef>Due Amount</th>
              <td
                mat-cell
                *matCellDef="let element; let i = index"
                [formGroupName]="i"
              >
                <mat-form-field floatLabel="auto" class="wp-100">
                  <input
                    allowDecimal
                    matInput
                    [value]="element.dueAmount"
                    autocomplete="off"
                    formControlName="dueAmount"
                    maxlength="{{ maxLength.maxLength10 }}"
                  />
                </mat-form-field>
              </td>
            </ng-container>
            <ng-container matColumnDef="amount">
              <th mat-header-cell *matHeaderCellDef>
                Amount
                <span class="text-danger-300">*</span>
              </th>
              <td
                mat-cell
                *matCellDef="let element; let i = index"
                [formGroupName]="i"
              >
                <mat-form-field floatLabel="auto" class="wp-100">
                  <input
                    matInput
                    [value]="element.amount"
                    autocomplete="off"
                    formControlName="amount"
                    maxlength="{{ maxLength.maxLength10 }}"
                    allowDecimal
                    zeroNotAllowed
                    (input)="onAmountChange()"
                    (keypress)="checkAmount(i)"
                  />
                </mat-form-field>
              </td>
            </ng-container>
            <ng-container matColumnDef="closeButton">
              <th mat-header-cell *matHeaderCellDef class="w-15"></th>
              <td
                mat-cell
                *matCellDef="let element; let i = index"
                [formGroupName]="i"
                class="text-align-center"
              >
                <button
                  class="close-btn"
                  type="button"
                  mat-button
                  disableRipple
                  (click)="onDeleteReceiptDetails(i)"
                >
                  <mat-icon>delete_outline</mat-icon>
                </button>
              </td>
            </ng-container>
            <tr
              mat-header-row
              *matHeaderRowDef="displayProductDetailsColumns; sticky: true"
            ></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayProductDetailsColumns"
            ></tr>
          </table>
        </ng-container>
      </form>
    </div>
    <div class="mb-1 mt-1 d-flex justify-space-between">
      <div>
        <a class="link" href="javascript:void(0)" (click)="addNewRow()"
          >Add New Line</a
        >
        <a
          *ngIf="receiptDetailArray.length > 0"
          class="link"
          href="javascript:void(0)"
          (click)="clearForm()"
          >Clear All Lines
        </a>
      </div>
    </div>
  </div>
</div>
